export const PERCENTS_LIQUIDATION_LIMIT = 0.95;
export const PERCENTS_FULL_LIQUIDATION = 1;